import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const advanceApi = createApi({
  reducerPath: 'advanceApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Advance', 'DetailCus'],
  endpoints: (builder) => ({
    getListAdvance: builder.query({
      query: (params) => ({
        url: NetWork.advance,
        method: GET,
        params: params
      }),
      // providesTags: (result: ReponseData2<{ rows: AdvanceType[] }>) =>
      //   result ? [{ type: 'Advance', id: 'LIST' }] : [])
      providesTags: (result) => (result ? [{ type: 'Advance', id: 'LIST' }] : [])
    }),
    getAdvanceById: builder.query({
      query: (params: { advanceId: number }) => ({
        url: NetWork.advanceId(params.advanceId),
        method: GET
      }),
      providesTags: (result) => (result ? [{ type: 'DetailCus', id: 'DETAIL' }] : [])
    }),
    addAdvance: builder.mutation({
      query: (data) => ({
        url: NetWork.advance,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'Advance', id: 'LIST' }]
    }),
    updateAdvance: builder.mutation({
      query: (data) => ({
        url: NetWork.advanceId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'Advance', id: 'LIST' }]
    }),
    deleteAdvance: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.advance,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'Advance', id: 'LIST' }] // Vô hiệu hóa tag 'Advance' với id 'LIST' để gọi lại getListAdvance
      }),
      invalidatesTags: [{ type: 'Advance', id: 'LIST' }]
    }),
    changeStatusAdvance: builder.mutation({
      query: (data: { advanceId: number; params: { isActive: boolean } }) => ({
        url: NetWork.advanceId(data.advanceId),
        method: PATCH,
        params: data.params
      })
    }),
    updateStatusApprovalAdvance: builder.mutation({
      query: (data: { id: number; params: { statusApproval: string; reasonCancel?: string } }) => ({
        url: NetWork.advanceApproval(data.id),
        method: PUT,
        params: data.params
      }),
      invalidatesTags: [{ type: 'Advance', id: 'LIST' }]
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListAdvanceQuery,
  useDeleteAdvanceMutation,
  useAddAdvanceMutation,
  useGetAdvanceByIdQuery,
  useUpdateAdvanceMutation,
  useChangeStatusAdvanceMutation,
  useUpdateStatusApprovalAdvanceMutation
} = advanceApi
